export const primitiveColors = {
  'matcha-green': 'rgba(0, 185, 109, 1)',
  'matcha-purple': 'rgba(89, 50, 243, 1)',
  'matcha-orange': 'rgba(237, 144, 77, 1)',
  'matcha-red': 'rgba(255, 101, 109, 1)',
  'white-700': 'rgba(255, 255, 255, 0.7)',
  'white-1000': 'rgba(255, 255, 255, 1)',
  'alphadark-100': '#fcfcfd',
  'alphadark-200': 'rgba(254, 254, 255, 0.97)',
  'alphadark-300': 'rgba(250, 250, 253, 0.96)',
  'alphadark-400': 'rgba(249, 249, 253, 0.92)',
  'alphadark-500': 'rgba(246, 247, 255, 0.85)',
  'alphadark-600': 'rgba(241, 242, 255, 0.77)',
  'alphadark-700': 'rgba(223, 227, 253, 0.61)',
  'alphadark-800': 'rgba(207, 212, 254, 0.38)',
  'alphadark-900': 'rgba(204, 208, 251, 0.29)',
  'alphadark-1000': 'rgba(205, 209, 250, 0.25)',
  'alphadark-1100': 'rgba(196, 204, 244, 0.18)',
  'alphadark-1200': 'rgba(196, 204, 244, 0.14)',
  'alphadark-1300': 'rgba(175, 188, 230, 0.08)',
  'alphadark-1400': 'rgba(150, 175, 205, 0.04)',
  'alphadark-1500': '#19191e',
  'alphadark-1600': 'rgba(0, 13, 5, 0.08)',
  'alphalight-100': 'rgba(65, 32, 40, 0.02)',
  'alphalight-200': 'rgba(55, 55, 80, 0.04)',
  'alphalight-300': 'rgba(22, 22, 72, 0.06)',
  'alphalight-400': 'rgba(15, 15, 55, 0.1)',
  'alphalight-500': 'rgba(8, 14, 55, 0.17)',
  'alphalight-600': 'rgba(9, 13, 55, 0.26)',
  'alphalight-700': 'rgba(2, 6, 48, 0.43)',
  'alphalight-800': 'rgba(3, 7, 36, 0.64)',
  'alphalight-900': 'rgba(1, 2, 25, 0.7)',
  'alphalight-1000': 'rgba(2, 3, 22, 0.73)',
  'alphalight-1100': 'rgba(1, 2, 18, 0.78)',
  'alphalight-1200': 'rgba(1, 2, 14, 0.81)',
  'alphalight-1300': 'rgba(2, 3, 12, 0.86)',
  'alphalight-1400': 'rgba(2, 3, 10, 0.89)',
  'alphalight-1500': 'rgba(2, 2, 8, 0.91)',
  'alphalight-1600': 'rgba(0, 1, 6, 0.91)',
  'basic-black': '#000000',
  'basic-white': '#ffffff',
  'gray-40': 'rgba(146, 153, 166, 1)',
  'gray-100': '#fcfcfd',
  'gray-200': '#f7f7f8',
  'gray-300': '#f1f1f4',
  'gray-400': '#e7e7eb',
  'gray-500': '#d5d6dd',
  'gray-600': '#bfc0cb',
  'gray-700': '#9294a6',
  'gray-800': '#5e6073',
  'gray-900': '#4d4e5e',
  'gray-1000': '#464755',
  'gray-1100': '#393a46',
  'gray-1200': '#31323c',
  'gray-1300': '#25262e',
  'gray-1400': '#1e1f25',
  'gray-1500': '#19191e',
  'gray-1600': '#17181c',
  'green-100': '#f5fcf7',
  'green-200': '#f0faf3',
  'green-300': '#e9f7ee',
  'green-400': '#d7f2e0',
  'green-500': '#c0eace',
  'green-600': '#a3e0b8',
  'green-700': '#83d59f',
  'green-800': '#61ca85',
  'green-900': '#3ebe6a',
  'green-1000': '#3aa761',
  'green-1100': '#368d57',
  'green-1200': '#32774e',
  'green-1300': '#2f6346',
  'green-1400': '#2d5541',
  'green-1500': '#2c4e3e',
  'green-1600': '#294038',
  'orange-100': '#fffdfa',
  'orange-200': '#fffbf5',
  'orange-300': '#fff5ed',
  'orange-400': '#feead7',
  'orange-500': '#fddaba',
  'orange-600': '#fcc797',
  'orange-700': '#fbb16f',
  'orange-800': '#fa9a44',
  'orange-900': '#f97f12',
  'orange-1000': '#d97216',
  'orange-1100': '#b5631b',
  'orange-1200': '#95551f',
  'orange-1300': '#7a4a23',
  'orange-1400': '#674225',
  'orange-1500': '#5c3d27',
  'orange-1600': '#493529',
  'purple-100': '#fafaff',
  'purple-200': '#f7f5ff',
  'purple-300': '#f2effe',
  'purple-400': '#e3ddfd',
  'purple-500': '#cfc3fc',
  'purple-600': '#b6a5fa',
  'purple-700': '#9a83f8',
  'purple-800': '#7c5df6',
  'purple-900': '#5932f3',
  'purple-1000': '#5130d5',
  'purple-1100': '#482eb4',
  'purple-1200': '#412c96',
  'purple-1300': '#3a2b7d',
  'purple-1400': '#352a6b',
  'purple-1500': '#332961',
  'purple-1600': '#2e284f',
  'red-100': '#fefbfb',
  'red-200': '#fdf6f6',
  'red-300': '#fbeced',
  'red-400': '#f6d4d6',
  'red-500': '#f0b5b8',
  'red-600': '#e98f94',
  'red-700': '#e0646b',
  'red-800': '#d7363f',
  'red-900': '#cc000b',
  'red-1000': '#b30610',
  'red-1100': '#970c16',
  'red-1200': '#7e121b',
  'red-1300': '#681720',
  'red-1400': '#591a23',
  'red-1500': '#501c25',
  'red-1600': '#412028',
};
